<template>
  <f7-page class="main-countBox-perWorker-lines">
    <template #fixed>
      <TheNavbar
        class="content-navbar"
        :style="appTheme"
        :nav-title="productionLine.Nombre"
        back-btn-enable
        :add-btn-enable="!hideAddButton"
        :back-callback="GoBack"
        @add-btn="popupNuevoArticulo = true"
      >
        <template #btn-right>
          <img
            src="@/static/icons/ic_play_green.svg"
            width="37"
            class="padding-left-half"
            @click="EventBoxAssignment"
          >
          <img
            src="@/static/icons/ic_refresh_blue.svg"
            width="37"
            class="padding-left-half"
            @click="EventRefreshData"
          >
        </template>
      </TheNavbar>
    </template>
    <UCToolbar
      class="content-toolbar"
      :is-bottom="false"
      :data="dataTabbar"
      tabbar-link="1"
    >
      <template #tabs>
        <f7-tabs>
          <f7-tab
            id="tab-1"
            class="page-content"
            tab-active
          >
            <div
              v-if="boxCountList != null && boxCountList.length > 0 && boxCountList[0].length > 0 && !preloaderMain"
              class="accordion noassigned-accordion"
            >
              <f7-list
                v-for="(option, i) in boxCountList[0]"
                :key="i"
                accordion-list
                class="custom-accordion"
              >
                <f7-list-item
                  accordion-item
                  :opened="true"
                  class="accordion-item-opened"
                >
                  <template #title>
                    <div>
                      <span class="accordion-title-group-name">
                        {{ option.NombreAgrupacion }}
                      </span>
                    </div>
                  </template>

                  <f7-accordion-content
                    v-for="(producto, j) in option.Producto"
                    :key="j"
                  >
                    <div>
                      <UCAcordeon
                        title-option="NombreLista"
                        :items="[producto.Trabajador]"
                        class="mainAcordeon"
                        :show-checkbox="true"
                        :show-badge="true"
                        badge-text-color="var(--his-oliva)"
                        font-color="var(--his-dark-blue)"
                        primary="var(--his-light-blue)"
                        checkbox-row-title="Todos"
                        :busqueda-con-checkbox="true"
                        :after-title="false"
                        :after-icon="true"
                        :disabled-btn-options-no-items-selected="false"
                        :function-count-badge="FunctionCountBadge"
                        :search-with-checkbox="true"
                        @open-options="elaboratedArticlesList.length !== 0 ? actionChangesOpened = true : null"
                        @change-selected="EventWorkerSelected"
                        @check-all-option="EventCheckAllOption"
                      >
                        <template #subOptionSubtitle="{ item }">
                          <f7-list-item>
                            <div class="content-accordion-items">
                              <div
                                v-for="(trabajadores, t) in item.Trabajadores"
                                :key="t"
                                class="content-accordion-items__list"
                              >
                                <div class="title">
                                  {{ trabajadores != null ? (trabajadores.Sujeto != null
                                    ? trabajadores.Sujeto.NombreSujeto : trabajadores.Id) : 'Sin trabajador' }}
                                </div>
                                <div class="subtitle">
                                  {{ trabajadores != null ? (trabajadores.Codigo != null ? trabajadores.Codigo : 'sin codigo') : 'sin Codigo' }}
                                </div>
                              </div>
                              <div class="content-accordion-items__palet">
                                <div class="content-accordion-items__palet--items">
                                  <span class="padding-left-half"> {{ item.Cantidad }}</span>
                                  <img
                                    class="padding-right-half"
                                    src="@/static/icons/ic_box_red.svg"
                                    width="17"
                                    style="fill: #ba5333; padding-left: 5px;"
                                  >
                                </div>
                              </div>
                            </div>
                          </f7-list-item>
                        </template>
                      </UCAcordeon>
                    </div>
                  </f7-accordion-content>
                </f7-list-item>
              </f7-list>
            </div>
            <div v-else>
              <span
                v-if="!preloaderMain"
                class="content-text"
              > Actualmente no hay cajas sin asignar </span>
              <UCPreload :show="preloaderMain" />
            </div>
          </f7-tab>
          <f7-tab
            id="tab-2"
            class="page-content"
          >
            <div
              v-if="boxCountList !== null && boxCountList.length > 1 && boxCountList[1].length > 0 && !preloaderMain"
              class="assigned-accordion"
            >
              <div
                v-for="(grupo, i) in boxCountList[1]"
                :key="i"
              >
                <UCAcordeon
                  v-for="(palet, paletKey) in grupo.Palets"
                  :key="paletKey"
                  class="mainAcordeon"
                  title-option="NombreAgrupacion"
                  :items="[palet.Palet]"
                  primary="'var(--his-lavender-blue)'"
                  secondary="'var(--his-lavender-blue)'"
                  font-color="'var(--his-dark-blue)'"
                  :show-checkbox="true"
                  :show-badge="false"
                  checkbox-row-title="Todos"
                  badge-text-color="var(--his-oliva)"
                  :closed="true"
                  :after-title="false"
                  :busqueda-con-checkbox="true"
                  :search-in="['.title', '.subtitle', '.text']"
                  :disabled-btn-options-no-items-selected="false"
                  :search-with-checkbox="true"
                  @change-selected="EventWorkerSelected"
                  @check-all-option="EventCheckAllOption"
                >
                  <template #titleOption="{ option }">
                    <div
                      class="boxes-quantity"
                      :class="{
                        'boxes-quantity__full': SumDoneQuantity(option.items) === option.CantidadMaxima,
                      }"
                    >
                      {{ `${SumDoneQuantity(option.items)} ${$t('common.of')} ${option.CantidadMaxima}` }}
                    </div>
                    <div class="content-item-title">
                      <span class="packaging"> {{ option.NombreEnvase }} </span>
                      <span class="product"> {{ option.NombreProducto }} </span>
                    </div>
                  </template>
                  <template #subOptionSubtitle="{ item }">
                    <div class="content-accordion-items">
                      <div
                        v-for="(trabajadores, t) in item.Trabajadores"
                        :key="t"
                        class="content-accordion-items__list"
                      >
                        <div class="title">
                          {{ trabajadores != null ? (trabajadores.Sujeto != null ? trabajadores.Sujeto.NombreSujeto
                            : trabajadores.Id) : 'Sin trabajador' }}
                        </div>
                        <div class="subtitle">
                          {{ trabajadores != null ? (trabajadores.Sujeto != null ? trabajadores.Codigo : 'Sin Codigo')
                            : 'Sin trabajador' }}
                        </div>
                      </div>
                      <div class="content-accordion-items__palet">
                        <div class="content-accordion-items__palet--items">
                          <span class="padding-left-half"> {{ item.Cantidad != null ? item.Cantidad : '' }} </span>
                          <img
                            class="padding-right-half padding-left-half"
                            src="@/static/icons/ic_box_red.svg"
                            width="17"
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </UCAcordeon>
              </div>
            </div>
            <div v-else>
              <span
                v-if="!preloaderMain"
                class="content-text"
              > Actualmente no hay cajas asignadas </span>
              <UCPreload :show="preloaderMain" />
            </div>
          </f7-tab>
        </f7-tabs>
      </template>
    </UCToolbar>
    <!-- ACTION DELETE -->
    <f7-actions
      class="content-action"
      style="background: #fff;"
      :grid="true"
      :opened="actionChangesOpened"
      @actions:closed="actionChangesOpened = false"
    >
      <f7-block>
        <f7-actions-label>
          {{ $t('common.whatDoYouWantToDo') }}
        </f7-actions-label>
        <div class="content-action__buttons">
          <f7-actions-button
            class="content-action__buttons--red"
            @click="EventDeleteWorkersList"
          >
            <template #media>
              <img
                src="@/static/icons/ic_delete.svg"
                width="50"
                class="img-delete"
              >
            </template>
            <span>{{ $t('common.delete') }}</span>
          </f7-actions-button>
        </div>
      </f7-block>
    </f7-actions>
    <!-- POP UP NEW ARTICLE -->
    <f7-popup
      class="content-popup-new-article hide-popup-scanner"
      :opened="popupNuevoArticulo"
      @popup:closed="popupNuevoArticulo = false"
    >
      <f7-page>
        <div class="content-filters padding">
          <div class="content-filters-search">
            <div class="content-filters__articles">
              <UCSearchEntityERP
                :title="$t('common.worker')"
                :placeholder="$t('searchEntity.worker.placeholder.searchWorker')"
                :search-text="$t('searchEntity.worker.searchText')"
                :search-cancellation-text="$t('searchEntity.worker.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.worker.searchNotFoundText')"
                :end-point-for-code-search="GetWorkerCodeSearch"
                :end-point-for-list="GetWorkerList"
                :property-entity-shown-input="['Codigo', 'Sujeto.NombreSujeto']"
                :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :qr-search-show="true"
                :qr-search-params="{
                  showInputButton: true,
                  fabButtonShow: false,
                  allowManualCodeEntry: false,
                  autoOpenCamera: true,
                }"
                @selection="EventSelectedWorker"
              />
            </div>
            <div class="content-filters__logistic-unit">
              <UCSearchEntityERP
                ref="UCProductComponent"
                :title="$t('common.product')"
                :placeholder="$t('searchEntity.product.placeholder.searchProduct')"
                :search-text="$t('searchEntity.product.searchText')"
                :search-cancellation-text="$t('searchEntity.product.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.product.searchNotFoundText')"
                :end-point-for-code-search="GetArticleCodeSearch"
                :end-point-for-list="GetArticlesList"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventSelectedArticle"
              />
            </div>
            <div class="content-filters__lotes">
              <UCSearchEntityERP
                ref="UCPackagingComponent"
                :title="$t('common.package')"
                :placeholder="$t('searchEntity.container.placeholder.searchContainer')"
                :search-text="$t('searchEntity.container.searchText')"
                :search-cancellation-text="$t('searchEntity.container.searchCancellationText')"
                :search-not-found-text="$t('searchEntity.container.searchNotFoundText')"
                :end-point-for-code-search="GetPackagingCodeSearch"
                :end-point-for-list="GetPackaging"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Nombre']"
                :property-entity-shown-list-subtitle="['Codigo']"
                :min-text-search="0"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                @selection="EventSelectedPackaging"
              />
            </div>
          </div>
          <div class="content-stepper--items text-align-center">
            <span class="content-stepper--items__title"> Indique la cantidad de cajas recolectadas </span>
            <f7-stepper
              ref="stepperBoxesQuantity"
              fill
              class="content-stepper--items__stepper"
              :manual-input-mode="true"
              :max="1000000"
              :value="boxesQuantity"
              @input="boxesQuantity = $event.target.value"
            />
          </div>
        </div>
        <div class="content-popup__buttons">
          <a
            class="color-red padding"
            @click="popupNuevoArticulo = false"
          >
            {{ $t('common.cancel').toUpperCase() }}
          </a>
          <a
            class="color-blue aceptar-button padding"
            @click="EventNewArticle"
          >
            {{ $t('common.accept').toUpperCase() }}
          </a>
        </div>
      </f7-page>
    </f7-popup>

    <!-- Mensajes de Confirmación Genéricos. -->
    <UCConfirmation ref="UCConfirmation" />
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useProductionStore } from '@/js/stores/production';
import { useTraceabilityStore } from '@/js/stores/traceability';

import TheNavbar from '@/components/TheNavbar.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import UCToolbar from '@/components/common/UCToolbar.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmCountBoxPerWorkerLines',
  components: {
    TheNavbar,
    UCAcordeon,
    UCSearchEntityERP,
    UCConfirmation,
    UCToolbar,
    UCPreload,
  },

  data() {
    return {
      assignedList: [],
      noAssignedList: [],
      boxesQuantity: 0, // Por defecto como mínimo debemos crear una caja.
      popupNuevoArticulo: false,
      actionChangesOpened: false,
      productionLine: null,
      elaboratedArticlesList: [],
      selectedArticle: null,
      selectedPackaging: null,
      selectedWorkers: null,
      hideAddButton: false,
      dataTabbar: [
        {
          title: 'Sin Asignar',
          badge: '',
        },
        {
          title: 'Asignadas',
          badge: '',
        },
      ],
      elementFilter: [],
      preloaderMain: false,
    };
  },
  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),
    ...mapWritableState(useProductionStore, ['boxCountList']),
    ...mapState(useTraceabilityStore, ['lineaDeProduccionSeleccionada']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },

    dataBadge() {
      if (this.noAssignedList != null) {
        return this.noAssignedList.filter((e) => e.Trabajadores.length > 0).length;
      }
      /*
      if (this.boxCountList != null && this.boxCountList.length > 0) {
        let countBox = 0;
        deb
        const x = this.noAssignedList.forEach((e) => { countBox += e.Cantidad; });
        return countBox;
        // this.boxCountList[0].forEach((e) => { debugger; e.Envases.forEach((el) => {  el.items.    countBox += el.Cantidad; }); });
        // return countBox;
        // return (this.boxCountList[0].length).toString();
      }
      */
      return '';
    },
  },

  created() {
    this.productionLine = this.lineaDeProduccionSeleccionada;
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.GetElaboratedArticles();
    },
    SumDoneQuantity(items) {
      Log(this, this.SumDoneQuantity.name);
      let sum = 0;
      items.forEach((box) => {
        sum += Number.parseInt(box.Cantidad, 10);
      });
      return sum;
    },

    GoBack() {
      Log(this, this.GoBack.name);
      this.boxCountList = null;
      f7.views.main.router.back();
    },

    async GetElaboratedArticles() {
      Log(this, this.GetElaboratedArticles.name);
      // HiDialog.Preloader(true, 'Cargando Articulos elaborados');
      this.preloaderMain = true;
      this.dataTabbar[0].badge = 0;
      await this.Conections_GetElaboratedArticles(this.productionLine.Id, 0);
      await this.Conections_GetElaboratedArticles(this.productionLine.Id, 1);
      this.boxCountList = this.elementFilter;
      this.dataTabbar[0].badge = this.dataBadge;
      // HiDialog.Preloader(false);
      this.preloaderMain = false;
    },

    GetAssignedList(asignedList) {
      Log(this, this.GetAssignedList.name);
      const asignados = [];
      const idsEnvase = [];

      asignedList.forEach((e) => {
        const { Id: idEnvase } = e.Envase;
        const { NumeroSerie: numeroSerie } = e.NumeroSerie;
        const { Id: numeroSerieId } = e.NumeroSerie;
        const { Nombre: nombreEnvase } = e.Envase;
        const { Nombre: nombreProducto } = e.Producto;
        const { CantidadEnvasesPrevista: cantidadMaxima } = e.NumeroSerie;

        const item = e;

        const codProducto = {};
        const envaseIndex = idsEnvase.indexOf(idEnvase);

        if (envaseIndex === -1) {
          idsEnvase.push(idEnvase);
          codProducto[numeroSerieId] = {
            Palet: {
              NombreAgrupacion: numeroSerie,
              NombreEnvase: nombreEnvase,
              NombreProducto: nombreProducto,
              CantidadMaxima: cantidadMaxima,
              items: [item],
            },
          };

          asignados.push({
            Palets: codProducto,
          });
        } else {
          const productoExist = numeroSerieId in asignados[envaseIndex].Palets;
          if (!productoExist) {
            asignados[envaseIndex].Palets[numeroSerieId] = {
              Palet: {
                NombreAgrupacion: numeroSerie,
                NombreEnvase: nombreEnvase,
                NombreProducto: nombreProducto,
                CantidadMaxima: cantidadMaxima,
                items: [item],
              },
            };
          } else {
            e.Trabajadores.forEach((worker) => {
              const idTrabajador = worker.Id;
              const trabajadoresIndex = asignados[envaseIndex].Palets[numeroSerieId].Palet.items.findIndex((f) => f.Trabajadores.some((t) => t.Id === idTrabajador));
              if (trabajadoresIndex === -1) {
                asignados[envaseIndex].Palets[numeroSerieId].Palet.items.push(item);
              } else {
                asignados[envaseIndex].Palets[numeroSerieId].Palet.items[trabajadoresIndex].Cantidad += 1;
              }
            });
          }
        }
      });

      this.OrdenarArray(asignados);
      this.elementFilter[1] = asignados.length === 0 ? [] : asignados;
    },

    OrdenarArray(array) {
      Log(this, this.OrdenarArray.name);
      // const maxCodigoPalet = Math.max(...array.flatMap((objeto) => Object.keys(objeto.Palets).map(Number)));

      array.sort((a, b) => {
        const codigoPaletA = Math.max(...Object.keys(a.Palets).map(Number));
        const codigoPaletB = Math.max(...Object.keys(b.Palets).map(Number));
        return codigoPaletB - codigoPaletA;
      });
    },

    GetNotAssignedList(notAssignedList) {
      Log(this, this.GetNotAssignedList.name);
      const sinAsignar = [];
      const idsEnvase = [];

      notAssignedList.forEach((e) => {
        // Si un ArticuloElaborado no tiene trabajadores no se mostraran en la vista.
        if (e.Trabajadores.length === 0) {
          return;
        }

        const { Id: idEnvase } = e.Envase;
        const { Nombre: nombreEnvase } = e.Envase;
        const { Nombre: nombreLista } = e.Producto;
        const codigoProducto = e.Producto.Codigo;

        const codProducto = {};

        const envaseIndex = idsEnvase.indexOf(idEnvase);

        const item = e;
        if (envaseIndex === -1) {
          idsEnvase.push(idEnvase);
          codProducto[codigoProducto] = {
            Trabajador: { NombreLista: nombreLista, items: [item] },
          };

          sinAsignar.push({
            EnvaseId: idEnvase,
            NombreAgrupacion: nombreEnvase,
            Producto: codProducto,
          });
        } else {
          const productoExist = codigoProducto in sinAsignar[envaseIndex].Producto;
          if (!productoExist) {
            sinAsignar[envaseIndex].Producto[codigoProducto] = {
              Trabajador: { NombreLista: nombreLista, items: [item] },
            };
          } else {
            e.Trabajadores.forEach((worker) => {
              const idTrabajador = worker.Id;
              const trabajadoresIndex = sinAsignar[envaseIndex].Producto[codigoProducto].Trabajador.items.findIndex((f) => f.Trabajadores.some((t) => t.Id === idTrabajador));

              if (trabajadoresIndex === -1) {
                sinAsignar[envaseIndex].Producto[codigoProducto].Trabajador.items.push(item);
              } else {
                sinAsignar[envaseIndex].Producto[codigoProducto].Trabajador.items[trabajadoresIndex].Cantidad += 1;
              }
            });
          }
        }
      });
      this.elementFilter[0] = sinAsignar.length === 0 ? [] : sinAsignar;
    },

    FunctionCountBadge(e) {
      Log(this, this.FunctionCountBadge.name);
      let sum = 0;
      e.items.forEach((element) => {
        sum += element.Cantidad;
      });
      return sum;
    },

    // ***************************************** EVENTOS ******************************************** \\
    EventSelectedWorker(value) {
      Log(this, this.EventSelectedWorker.name);
      this.selectedWorkers = value;
    },

    EventSelectedArticle(value) {
      Log(this, this.EventSelectedArticle.name);
      this.selectedArticle = value;
    },

    EventSelectedPackaging(value) {
      Log(this, this.EventSelectedPackaging.name);
      this.selectedPackaging = value;
    },

    EventCheckAllOption(value) {
      Log(this, this.EventCheckAllOption.name);
      const check = value[0].checked;
      const res = this.noAssignedList.filter((f) => value.some((s) => f.Producto.Id === s.Producto.Id && f.Envase.Id === s.Envase.Id && f.Trabajadores.length > 0 && f.Trabajadores[0].Id === s.Trabajadores[0].Id));
      res.forEach((e) => {
        e.checked = check;
        this.elaboratedArticlesList.push(e);
      });
      this.elaboratedArticlesList = this.elaboratedArticlesList.filter((f, i) => f.checked && this.elaboratedArticlesList.indexOf(f) === i);
    },

    EventRefreshData() {
      Log(this, this.EventRefreshData.name);
      this.boxCountList = null;
      this.GetElaboratedArticles();
      this.elaboratedArticlesList = [];
    },

    EventWorkerSelected(value) {
      Log(this, this.EventWorkerSelected.name);
      const check = value.checked;
      const res = this.noAssignedList.filter((f) => f.Producto.Id === value.Producto.Id && f.Envase.Id === value.Envase.Id && f.Trabajadores.length > 0 && f.Trabajadores[0].Id === value.Trabajadores[0].Id);
      res.forEach((e) => {
        e.checked = check;
        this.elaboratedArticlesList.push(e);
      });
      this.elaboratedArticlesList = this.elaboratedArticlesList.filter((f, i) => f.checked && this.elaboratedArticlesList.indexOf(f) === i);
    },

    async EventNewArticle() {
      Log(this, this.EventNewArticle.name);

      if (this.selectedWorkers === null) {
        HiNotification.Toast(this.$t('common.needToSelectAWorker'), 2000);
        return;
      }

      if (this.selectedArticle === null) {
        HiNotification.Toast(this.$t('common.needToSelectAProduct'), 2000);
        return;
      }

      if (this.selectedPackaging === null) {
        HiNotification.Toast(this.$t('common.needToSelectAPackage'), 2000);
        return;
      }
      if (this.boxesQuantity < 1) {
        HiNotification.Toast('Necesita una caja como mínimo', 2000);
        return;
      }

      try {
        HiDialog.Preloader(true, 'Registrando artículos...');

        const fecha = new Date();
        // CREAMOS UN ARTICULO ELABORADO CON LOS DATOS RECOGIDOS
        const resultado = [];

        for (let i = 0; i < this.boxesQuantity; i += 1) {
          resultado[i] = {
            Id: i + 1,
            Fecha: fecha.toISOString(),
            Envase: this.selectedPackaging,
            Producto: this.selectedArticle,
            Trabajadores: [this.selectedWorkers],
            LineaProduccion: this.lineaDeProduccionSeleccionada,
            Cantidad: 1,
            UsuarioCreacion: this.userEnviroment.EntornoDeTrabajo.Usuario,
          };
        }

        const result = await this.Conections_NewElaboratedArticle(resultado);
        if (result.valor) {
          HiNotification.Toast('Articulos registrados correctamente', 2000);
        } else {
          const msg = result.mensaje !== '' ? result.mensaje : 'Ocurrió un error al generar los articulos recolectados';
          HiNotification.Toast(msg, 2000);
        }

        this.$refs.UCPackagingComponent.Clear();
        this.$refs.UCProductComponent.Clear();
        this.$refs.stepperBoxesQuantity.setValue(1);
        this.boxesQuantity = 1;
        this.EventRefreshData();
      } catch (error) {
        LogError(this, this.EventNewArticle.name, error);
      } finally {
        HiDialog.Preloader(false);
      }
    },

    EventBoxAssignment() {
      Log(this, this.EventBoxAssignment.name);
      if (this.elaboratedArticlesList.length > 0 && this.elaboratedArticlesList !== null) {
        this.hideAddButton = true;
        this.$refs.UCConfirmation.create(
          'Asignación de Caja/s',
          'Se van a asignar las cajas pendientes a sus correspondientes palés, ¿Desea continuar?',
          () => {
            this.Conections_ExecuteAssignmentElaboratedArticle();
          },
        );
        this.$refs.UCConfirmation.show();
      } else {
        HiNotification.Toast('No existen cajas seleccionadas.', 2000);
      }
    },

    EventDeleteWorkersList() {
      Log(this, this.EventDeleteWorkersList.name);
      this.$refs.UCConfirmation.create(
        'Eliminar caja/s',
        'Esta acción eliminara la/s caja/s seleccionada/s. ¿Deseas continuar con la acción?',
        () => {
          this.Conexion_EliminarArticuloElaborado();
        },
      );
      this.$refs.UCConfirmation.show();
    },

    // ********************************************* CONEXIONES ************************************************* \\
    GetWorkerList() {
      Log(this, this.GetWorkerList.name);
      return APIErp.callWorkerList();
    },

    GetWorkerCodeSearch(params) {
      Log(this, this.GetWorkerCodeSearch.name);
      return callExecuteSPERP('ObtenerTrabajadorXTarjetaAsociadaRFIDNFC', [
        { NombreParametro: 'CodigoTarjeta', Valor: params },
      ], 'TrabajadorJSON');
    },

    GetArticleCodeSearch(params) {
      Log(this, this.GetArticleCodeSearch.name);
      return callExecuteSPERP('APPERPAGRO_ArticuloMateriaPrimaLeerXFiltro', [
        { NombreParametro: 'IdGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
        { NombreParametro: 'CadenaFiltro', Valor: params },
      ], 'Comun.ArticuloJSON');
    },
    GetArticlesList() {
      Log(this, this.GetArticlesList.name);
      return callExecuteSPERP('APPERPAGRO_ArticuloMateriaPrimaLeerXFiltro', [
        { NombreParametro: 'IdGrupoEmpresarial', Valor: this.userEnviroment.EntornoDeTrabajo.GrupoEmpresarial.Id },
        { NombreParametro: 'CadenaFiltro', Valor: '' },
      ], 'Comun.ArticuloJSON'); // Articulos materia prima Todos
    },

    GetPackaging() {
      return ConexionTA.callObtenerEnvasesParaRecoleccion(0, '');
    },

    GetPackagingCodeSearch(params) {
      return ConexionTA.callObtenerEnvasesParaRecoleccion(0, params);
    },

    async Conections_GetElaboratedArticles(idLineaProduccion, asignados) {
      Log(this, this.Conections_GetElaboratedArticles.name);
      try {
        const result = await callExecuteSPERP('APPERPAGRO_ArticulosElaboradosXLineaProduccion', [
          { NombreParametro: 'idLineaProduccion', Valor: idLineaProduccion },
          { NombreParametro: 'asignados', Valor: asignados },
          { NombreParametro: 'idUsuario', Valor: this.userEnviroment.EntornoDeTrabajo.Usuario.Id },
        ], 'Trazabilidad.ArticuloElaboradoJSON');
        if (result.statusText === 'OK' || result.status === 200) {
          if (asignados === 0) {
            this.noAssignedList = result.data; this.GetNotAssignedList(result.data);
          } else {
            this.assignedList = result.data; this.GetAssignedList(result.data);
          }
        }
      } catch (error) {
        LogError(this, this.Conections_GetElaboratedArticles.name, error);
      }
      return null;
    },

    async Conections_ExecuteAssignmentElaboratedArticle() {
      Log(this, this.Conections_ExecuteAssignmentElaboratedArticle.name);
      // PASAMOS UN ARTICULO ELABORADO CON ID PERO SIN NUMEROSERIE
      HiDialog.Preloader(true, 'Asignando articulos elaborados...');
      let resList = [];
      resList = this.noAssignedList.filter((f) => this.elaboratedArticlesList.some((s) => f.Producto.Id === s.Producto.Id && f.Trabajadores.length > 0 && f.Trabajadores[0].Id === s.Trabajadores[0].Id)
        && f.UsuarioCreacion.Id === this.userEnviroment.EntornoDeTrabajo.Usuario.Id);

      try {
        const result = await APIErp.callExecuteAllocationOfTheElementsManufactured(resList);
        if ((result.statusText === 'OK' || result.status === 200) && result.data.valor) {
          if (result.data.tag.length === resList.length) {
            HiNotification.Toast('Se han asignado todas los artículos elaborados', 2000);
          }
        } else
          if ((result.statusText === 'OK' || result.status === 200) && !result.data.valor) {
            if (result.data.tag.length > 0 && result.data.tag.length < resList.length) {
              HiNotification.Toast(`Se han asignado ${result.data.tag.length} artículos elaborados de los ${resList.length} solicitados`, 5000);
              return;
            }
            if (result.data.tag.length > 0 && result.data.tag.length < resList.length) {
              HiNotification.Toast(`Se han asignado ${result.data.tag.length} artículos elaborados de los ${resList.length} solicitados`, 5000);
              return;
            }
            if (result.data.tag.length === 0) {
              HiNotification.Toast(`No se asigno ningun artículo elaborado de los ${resList.length} solicitados`, 5000);
              return;
            }

            HiNotification.Toast(result.data.mensaje !== '' ? result.data.mensaje : 'Ocurrió un error al asignar los artículos elaborados', 2000);
            return;
          }
      } catch (error) {
        LogError(this, this.Conections_ExecuteAssignmentElaboratedArticle.name, error);
      } finally {
        HiDialog.Preloader(false);
        this.EventRefreshData();
      }
      HiDialog.Preloader(false);
    },

    async Conections_NewElaboratedArticle(lstElaboratedArticles) {
      Log(this, this.Conections_NewElaboratedArticle.name);
      try {
        const result = await APIErp.callNewElaboratedArticle(lstElaboratedArticles);
        if (result.statusText === 'OK' || result.status === 200) {
          return result.data;
        }
      } catch (error) {
        LogError(this, this.Conections_NewElaboratedArticle.name, error);
        return { valor: false, mensaje: 'No ha sido posible crear generar las cajas. Intentalo de nuevo más tarde' };
      }
      return null;
    },

    /** * Método Conexion_ObtenerArticulosElaboradosXNumeroSerie */
    async Conexion_EliminarArticuloElaborado() {
      Log(this, this.Conexion_EliminarArticuloElaborado.name);
      try {
        const result = await APIErp.callRemoveElaboratedArticle(this.elaboratedArticlesList);

        if (result.data.Tag.ERROR.length > 0) {
          HiNotification.Toast(`No se han podido eliminar ${result.Tag.ERROR.length} cajas`, 3000);
        } else {
          HiNotification.Toast(`Se han eliminado las ${result.data.Tag.OK.length} cajas`, 3000);
        }
      } catch (error) {
        HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
        LogError(this, this.Conexion_EliminarArticuloElaborado.name, error);
      } finally {
        this.GetElaboratedArticles();
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.main-countBox-perWorker-lines {
  .page-content {
    .content-text {
      height: calc(100vh - 36px - 74px);
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: Roboto;
      font-style: normal;
      text-align: center;
      font-weight: 300;
      font-size: 26px;
      line-height: 35px;
      color: #aaa1a1;
    }
  }

  .content-navbar-conex {
    padding: 0 7px;
  }

  .content-toolbar {
    --f7-page-navbar-offset: 0;
    height: calc(100vh - 87px);

    .toolbar {
      --f7-tabbar-link-active-bg-color: var(--his-orange);
      --f7-tabbar-link-inactive-color: rgb(255 255 255);

      --toolbar-font-size: 16px;
      --toolbar-bg-color: var(--his-slate-blue);
    }

    .noassigned-accordion,
    .assigned-accordion {
      max-height: calc(100vh - var(--f7-page-navbar-offset) - 45px - var(--information-bar-height));
    }

    .content-accordion-items {
      display: flex;
      justify-content: space-between;

      &__list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 5px;
        font-weight: 600;

        .title,
        .subtitle {
          overflow: hidden;
          padding-bottom: 2px;
          font-size: 15px;
          -webkit-line-clamp: 1;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .subtitle {
          color: var(--his-soft-blue);
          font-size: 13px;
          font-weight: 700;
        }
      }

      &__palet {
        color: #ba5333;
        font-size: 15px;

        &--items {
          margin: 2px;
        }
      }
    }
  }

  .mainAcordeon {
    .accordion-list {
      .accordion-item-opened {
        background-color: var(--his-light-blue);

        .item-inner {
          .item-link {
            &::after {
              border-top: 0;
            }
          }
        }
      }
    }

    .boxes-quantity {
      // Position in the right
      position: absolute;
      right: 48px;

      // Center the container
      top: 0;
      bottom: 0;
      margin: auto;

      // Other
      height: max-content;
      border-radius: 10px;
      padding: 4px 8px;
      font-size: 12px;
      background-color: #f5faff;
      color: var(--his-oliva);

      &__full {
        background-color: #e5f6d3;
        color: #66ba33;
      }
    }
  }
}

.mainAcordeon {
  .accordion-list {
    .accordion-item {
      .item-inner {
        .item-link {
          .item-title {
            font-weight: 700;
            width: -webkit-fill-available;

            .content-item-title {
              display: flex;
              flex-direction: column;
              width: calc(100% - 70px);

              .packaging,
              .product {
                color: var(--his-oliva);
                font-size: 14px;
                font-weight: 300;
                padding-top: 5px;
                -webkit-line-clamp: 1;
                text-overflow: ellipsis;
                -webkit-box-orient: vertical;
                display: -webkit-box;
                overflow: hidden;
              }
            }
          }

          &::after {
            border-top: 0;
            content-visibility: hidden;
          }

          div > .badge {
            background-color: var(--his-soft-blue);
          }
        }
      }
    }
  }
}

.noassigned-accordion {
  .accordion-item > .item-link {
    background-color: var(--his-slate-blue);
    --f7-list-chevron-icon-color: #fff;
    --f7-list-item-title-font-weight: 600;
  }

  .accordion-title-group-name {
    color: #fff;
  }

  .accordion-item-content {
    .media-item {
      --f7-list-item-padding-vertical: 5px;
    }
  }
}

.content-popup-new-article {
  .content-filters {
    background: var(--his-bg);
    height: calc(100% - 95px);

    .content-stepper--items {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 50px;

      &__stepper {
        padding-top: 20px;
      }
    }
  }

  .content-popup__buttons {
    display: flex;
    justify-content: space-between;
    background: var(--his-bg);
  }
}

.content-action__buttons {
  margin-left: 0;
  margin-right: 0;

  .actions-button {
    width: 35vw;
  }
}

.content-accordion-items__palet {
  width: 60px;
  text-align: right;
}

.content-accordion-items__palet--items {
  display: flex;
  justify-content: space-around;
  min-width: 55px;
  background-color: var(--his-mandarina-tint);
  border-radius: 4px;

  .padding-left-half {
    text-align: center;
  }
}

.storybook-action-sorted-accordion .content-list-checkbox-item {
  border-top: unset;
}
</style>
